import styled from 'styled-components';

import shadowImage from '../../assets/images/bg_shadow.png';

const BgShadow = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 1080px;
	background-image: url(${shadowImage});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	transition: opacity 0.4s ease;
	opacity: 0;
`;

export { BgShadow };
